import * as Yup from "yup";

export const UserValidation = {
  username: Yup.string()
    .trim()
    .min(3, "must be at least 3 characters long")
    .required("The username field is required."),
};

export const PersonValidation = {
  first_name: Yup.string().trim().required("The first name field is required."),
  middle_name: Yup.string().trim().optional().nullable(),
  last_name: Yup.string().trim().required("The last name field is required."),
  // contact_no: Yup.number()
  //   .required("The  contact number field is required")
  //   .test(
  //     "phl_contactNo",
  //     "Please check the length of the contact number",
  //     (value) => {
  //       const opt1Regex = /^\d{10}$/;
  //       const opt2Regex = /^(09|\+639|639)\d{9}$/;
  //       return opt1Regex.test(value) || opt2Regex.test(value);
  //     }
  //   ),
  contact_no: Yup.string()
    .required("The contact number field is required")
    .test(
      "phl_contactNo",
      "Please check the length of the contact number",
      (value) => {
        if (!value) return false; // Handle the empty or undefined value
        const opt1Regex = /^\d{10}$/;
        const opt2Regex = /^(09|\+639|639)\d{9}$/;
        return opt1Regex.test(value) || opt2Regex.test(value);
      }
    ),
  email: Yup.string()
    .trim()
    .email("Invalid email address")
    .required("The email field is required."),
  gender: Yup.string().trim().nullable(),
  birthday: Yup.string().trim().nullable(),
  // .required("The birthday field is required"),
};

Yup.addMethod(Yup.string, "strongPassword", strongPasswordMethod);

function strongPasswordMethod() {
  return this.test("strongPasswordTest", function (value) {
    const { path, createError } = this;
    switch (Boolean(value)) {
      case !!value && value.length < 6:
        return createError({
          path,
          message: "Password must be at least 6 characters long.",
        });
      case !/^(?=.*[a-z])/.test(value):
        return createError({
          path,
          message: "Password must include lowercase letter",
        });
      case !/^(?=.*[A-Z])/.test(value):
        return createError({
          path,
          message: "Password must include uppercase letter",
        });
      case !/^(?=.*[0-9])/.test(value):
        return createError({ path, message: "Password must include digit" });
      case !/^(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_{|}~`])/.test(value):
        return createError({
          path,
          message: "Password must include special character",
        });
      default:
        return true;
    }
  });
}

export const ClientSignUpSchema = Yup.object({
  ...UserValidation,
  ...PersonValidation,
  acknowledge: Yup.boolean()
    .required("You must acknowledge the terms and conditions.")
    .oneOf([true], "You must acknowledge the terms and conditions."),
  password: Yup.string()
    .required("The password field is required")
    .strongPassword(),
});
export const ServerSignUpSchema = Yup.object({
  user: Yup.object().shape({
    ...UserValidation,
    user_role_id: Yup.number().required("The user role id is required."),
  }),
  person: Yup.object().shape({ ...PersonValidation }),
});

export const ServerSignUpGeneralSchema = Yup.object({
  // user: Yup.object().shape({
  //     user_role_id: Yup.number()
  //                     .required('The user role id is required.'),
  // }),
  person: Yup.object().shape({ ...PersonValidation }),
});

export const UserSchema = Yup.object({
  first_name: Yup.string().trim().required("The first name field is required."),
  last_name: Yup.string().trim().required("The last name field is required."),
  contact_no: Yup.string()
    .trim()
    .required("The contact no. field is required."),
  gender: Yup.string().trim().required("The gender field is required."),
  email: Yup.string()
    .trim()
    .email("Invalid email address.")
    .required("The email field is required."),

  // username: Yup.string()
  //     .trim()
  //     .min(3, 'must be at least 3 characters long')
  //     .required('The username field is required.'),
  password: Yup.string()
    .required("The password field is required")
    .strongPassword(),

  user_role_id: Yup.number().required("The user role id is required."),
});

export const UserAccountSchema = Yup.object({
  ...UserValidation,
  password: Yup.string()
    .required("The password field is required")
    .strongPassword(),
});

export const ServerUserAccountSchema = Yup.object({
  id: Yup.number().required("The id field is required."),
  user: Yup.object().shape({
    ...UserValidation,
    user_role_id: Yup.number().required("The user role id is required."),
  }),
});

export const UserAccessSchema = Yup.object({
  user_role_id: Yup.number().required("The user role id is required."),
});

export const ServerUserAccessSchema = Yup.object({
  id: Yup.number().required("The id field is required."),
  user: Yup.object().shape({
    user_role_id: Yup.number().required("The user role id is required."),
  }),
});

export const UserActivitySchema = Yup.object({
  user_id: Yup.number().required("The user_id field is required."),
  user_name: Yup.string().trim().required("The user_name field is required."),
  title: Yup.string().trim(),
  body: Yup.string().trim(),
  type: Yup.string().trim().required("The type field is required."),
  reference_id: Yup.number().required("The reference_id field is required."),
  status: Yup.string().trim().required("The status field is required."),
});

export const UserDeviceSchema = Yup.object({
  user_id: Yup.number().required("The user_id field is required."),
  browser_full_version: Yup.string().required(
    "The browser_full_version field is required."
  ),
  browser_major_version: Yup.string().required(
    "The browser_major_version field is required."
  ),
  browser_name: Yup.string().required("The browser_name field is required."),
  engine_name: Yup.string().required("The engine_name field is required."),
  engine_version: Yup.string().required(
    "The engine_version field is required."
  ),
  is_browser: Yup.string().required("The is_browser field is required."),
  os_name: Yup.string().required("The os_name field is required."),
  os_version: Yup.string().required("The os_version field is required."),
  user_agent: Yup.string().required("The user_agent field is required."),
  ip_address: Yup.string().required("The ip_address field is required."),
  user_id: Yup.string().required("The user_id field is required."),
});

// Person Model

export const ServerPersonSchema = Yup.object({
  person: Yup.object().shape({ ...PersonValidation }),
});
export const ClientPersonSchema = Yup.object({
  ...PersonValidation,
});

export const EmployeeMetaValidation = Yup.object({
  ...PersonValidation,
});

export const UserDeleteSchema = Yup.object({
  id: Yup.number().required("The User ID is required."),
});
const PersonObjMultiDimentional = {
  person: {
    firstName: "kevin",
    lastName: "carpio",
    age: 29,
  },
  user: {
    username: "kcarpio",
    password: "reactd3v",
  },
  media: {
    type: "User Photo",
    path: "https://some-image-path/photo1.jpg",
  },
};

const PersonFlatObj = {
  firstName: "kevin",
  lastName: "carpio",
  age: 29,

  username: "kcarpio",
  password: "reactd3v",

  type: "User Photo",
  path: "https://some-image-path/photo1.jpg",
};

export const UserStatusSchema = Yup.object({
  status: Yup.string().trim().required("The status field is required."),
});
